<script setup lang="ts">
const gameStore = useGameStore();

function copyToClipboard(text: string) {
  navigator.clipboard.writeText(text);
}
</script>

<template>
  <div class="space-y-1 text-xs text-base-priority">
    <div
      v-for="([property, val], index) in Object.entries(gameStore.currentGame)"
      :key="index"
      class="grid grid-cols-2 hover:invert bg-primary cursor-pointer px-1"
      @click="copyToClipboard(String(val))"
    >
      <span>{{ property }}:</span>
      <span>{{ val }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
